import { render, staticRenderFns } from "./ReferenceList.vue?vue&type=template&id=87f0fc1c"
import script from "./ReferenceList.vue?vue&type=script&lang=js"
export * from "./ReferenceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports